/**
 * @file
 * Shared types for Aoy component
 */

import { AnglerId } from '../../types';

export interface IAoyAngler {
  id: AnglerId;
  type: AoyTournamentType;
  // Angler profile value referencing Drupal node.
  tms?: string;
  fishermenid?: number;
  name: string;
  location: string;
  score: number;
  tourYear: number;
  rank: number;
  city: string;
  weight: number;
}

export interface IAoyFirstPlaceAngler {
  name: string;
  score: number;
  city: string;
  location: string;
  tms: AnglerId;
}

export interface IAoyTableRow {
  Rank: JSX.Element;
  Name: JSX.Element;
  PTS: JSX.Element;
}

export enum AoyRanks {
  FIRST_PLACE = 1,
}

export enum AoyTournamentType {
  AOY = 91,
  ROY = 90,
  EQS = 99,
  TOTAL_OPENS_PRO = 501,
  TOTAL_OPENS_CO = 500,
  EASTERN_OPENS = 531,
  CENTRAL_OPENS = 551,
  NORTHERN_OPENS_PRO = 511,
  NORTHERN_OPENS_CO = 510,
  EASTERN_OPENS_PRO = 531,
  EASTERN_OPENS_CO = 530,
  CENTRAL_OPENS_PRO = 551,
  CENTRAL_OPENS_CO = 550,
  SOUTHERN_OPENS_PRO = 521,
  SOUTHERN_OPENS_CO = 520,
  DIVISION_1_CO = 1190,
  DIVISION_1_PRO = 1191,
  DIVISION_2_CO = 1200,
  DIVISION_2_PRO = 1201,
  DIVISION_3_CO = 1210,
  DIVISION_3_PRO = 1211,
  KAYAK = 1,
}

export enum AoyTournamentName {
  AOY = 'Angler of the Year',
  ROY = 'Rookie of the Year',
  TOTAL_OPENS_PRO = 'Opens Aoy - PRO',
  TOTAL_OPENS_CO = 'Opens Aoy - CO',
  NORTHERN_OPENS_PRO = 'Northern Opens - Pro',
  NORTHERN_OPENS_CO = 'Northern Opens - Co',
  EASTERN_OPENS_PRO = 'Eastern Opens - Pro',
  EASTERN_OPENS_CO = 'Eastern Opens - Co',
  CENTRAL_OPENS_PRO = 'Central Opens - Pro',
  CENTRAL_OPENS_CO = 'Central Opens - Co',
  SOUTHERN_OPENS_PRO = 'Southern Opens - Pro',
  SOUTHERN_OPENS_CO = 'Southern Opens - Co',
  DIVISION_1_CO = 'Opens Division 1 - Co',
  DIVISION_1_PRO = 'Opens Division 1 - Pro',
  DIVISION_2_CO = 'Opens Division 2 - Co',
  DIVISION_2_PRO = 'Opens Division 2 - Pro',
  DIVISION_3_CO = 'Opens Division 3 - Co',
  DIVISION_3_PRO = 'Opens Division 3 - Pro',
  KAYAK = 'Kayak Angler of the Year'
}
